export enum UserSettingName {
  Locale = 'locale',
  Theme = 'theme',
  DateFormat = 'dateFormat',
  TimeFormat = 'timeFormat',
  HideFloatingNotifications = 'hideFloatingNotifications',
  DeveloperMode = 'developerMode',
  AllowedLlmToolNames = 'allowedLlmToolNames',
  LlmPermissionMode = 'llmPermissionMode',
  MuteNotificationsWhenBusy = 'muteNotificationsWhenBusy',
  BusyBreakthroughNotificationTypes = 'busyBreakthroughNotificationTypes',
  ProductTourState = 'productTourState',
  CharacterKeyShortcuts = 'characterKeyShortcuts',
  LightModernPaletteVariant = 'lightModernPaletteVariant',
  LightModernBadgeVariant = 'lightModernBadgeVariant',
}
